

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://d1bbe4458f884c6ba40890087b9ca2f9@sentry.wixpress.com/5773", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/bdd178f9326b1ce3/packages/appointment-waitlist-form/src/components/AppointmentWaitlistForm/Widget/index.tsx';
    import createController from '/home/builduser/work/bdd178f9326b1ce3/packages/appointment-waitlist-form/src/components/AppointmentWaitlistForm/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'AppointmentWaitlistForm';
    var projectName = 'appointment-waitlist-form';
    var sentryConfig = {
      DSN: 'https://d1bbe4458f884c6ba40890087b9ca2f9@sentry.wixpress.com/5773',
      id: 'undefined',
      projectName: 'appointment-waitlist-form-31',
      teamName: 'bookings',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/bdd178f9326b1ce3/packages/appointment-waitlist-form/src/components/AppointmentWaitlistForm/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["test"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/bdd178f9326b1ce3/packages/appointment-waitlist-form/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"waitlist-form.form-dialog-header-title":"Join Waitlist","waitlist-form.form-dialog-header-loading-service-details":"Loading service details...","waitlist-form.form-dialog-header-service-details-multi-service":"{numberOfServices} services","waitlist-form.form-dialog-header-service-details":"{serviceName} | {paymentDescription}","waitlist-form.service.payment.from-price":"From {price}","waitlist-form.form-dialog-success-title":"You've been added to the waitlist","waitlist-form.form-dialog-success-text":"Thanks for joining the waitlist.<br>We will be in touch soon.","waitlist-form.form-dialog-success-button":"Done","waitlist-form.waitlist-notification-text":"Can’t find the date or time you’re looking for? <Link>Join the waitlist</Link>","waitlist-form.settings.tabs.main":"Main","waitlist-form.settings.tabs.design":"Design","waitlist-form.settings.main.description":"Let your clients join the Appointment Waitlist if they can't find an available time they want to book.","waitlist-form.settings.main.title":"Appointment Waitlist","waitlist-form.settings.design.notification-background-color":"Background color & opacity","waitlist-form.settings.design.notification-link-text-color":"Link color","waitlist-form.settings.design.text-font":"Text","waitlist-form.settings.design.font-picker-title":"Choose a font","waitlist-form.settings.design.main-header":"Design","waitlist-form.settings.main.manage-button":"Manage Waitlist"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "894e612f-f5b5-4641-aa40-696963c689d2";
    var componentId = "133487e7-5c2e-42e9-aba7-c75789861e75";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/bdd178f9326b1ce3/packages/appointment-waitlist-form/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
